import React from "react";
import { Colors } from "../../utils/colors";
import { SelectCircleInitialHeader } from "../selectCircleInitialHeader/SelectCircleInitialHeader";
import { ClickableText } from "../clickableText/ClickableText";
import {
  useSectionStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import { SelectPlayerBottomSheet } from "../selectPlayerBottomSheet/SelectPlayerBottomSheet";
import { SelectCircleExpandedActionButtons } from "../selectCircleExpandedActionButtons/SelectCircleExpandedActionButtons";
import { PlayerSelectionBottomSheetType } from "../../apis/types";
import { ExcludePlayerBottomSheet } from "../excludePlayerBottomSheet/ExcludePlayerBottomSheet";
import { ExcludedPlayersList } from "../excludedPlayersList/ExcludedPlayersList";
import { SelectedPlayersList } from "../selectedPlayersList/SelectedPlayersList";
import { GuestPlayersList } from "../guestPlayersList/GuestPlayersList";
import { CircleSectionsList } from "../circleSectionsList/CircleSectionsList";
import { observer } from "mobx-react-lite";

type props = {};

export const SelectCircleExpanded: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  const sectionStore = useSectionStore();

  return (
    <div
      style={{
        backgroundColor: Colors.green,
        borderRadius: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        paddingTop: 20,
        marginTop: 20,
      }}>
      <SelectCircleInitialHeader />
      <CircleSectionsList />
      {/* <CircleGraph size={370} /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center", // Add this to center align horizontally
          marginTop: 10,
          width: "100%", // Ensure the container takes full width
        }}>
        <SelectedPlayersList
          onRemoveIconClick={(p) => selectCircleStore.togglePlayerSelection(p)}
        />
        <GuestPlayersList />
      </div>
      <ClickableText
        text={"Select players"}
        onClick={() => {
          selectCircleStore.setBottomSheetType(
            PlayerSelectionBottomSheetType.selectPlayers
          );
        }}
        textStyle={{
          fontWeight: 500,
          fontSize: 14,
          color: Colors.gold,
          textAlign: "center",
          marginTop: 20,
          marginBottom: 30,
        }}
      />
      <ExcludedPlayersList
        onExcludeMore={() => {
          selectCircleStore.setBottomSheetType(
            PlayerSelectionBottomSheetType.excludePlayers
          );
        }}
      />
      <SelectCircleExpandedActionButtons
        // onExclude={
        //   selectCircleStore.excludedPlayers.length
        //     ? undefined
        //     : () => {
        //         selectCircleStore.setBottomSheetType(
        //           PlayerSelectionBottomSheetType.excludePlayers
        //         );
        //       }
        // }
        onNext={() => {
          sectionStore.onExpandPaymentSection();
        }}
      />
      <SelectPlayerBottomSheet
        showBottomSheet={
          selectCircleStore.bottomSheetType ===
          PlayerSelectionBottomSheetType.selectPlayers
        }
        closeBottomSheet={() => {
          selectCircleStore.setBottomSheetType(
            PlayerSelectionBottomSheetType.none
          );
        }}
      />
      <ExcludePlayerBottomSheet
        showBottomSheet={
          selectCircleStore.bottomSheetType ===
          PlayerSelectionBottomSheetType.excludePlayers
        }
        closeBottomSheet={() => {
          selectCircleStore.setBottomSheetType(
            PlayerSelectionBottomSheetType.none
          );
        }}
      />
      {/* {selectCircleStore.isAIWillSelectPlayerModalVisible ? (
        <UltraAIFindModal visible={true} />
      ) : null} */}
    </div>
  );
});
